// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-pages-classes-ClassesPage-ClassesPage-module__icon--RkXFv {
  color: #343a41;
}
.src-pages-classes-ClassesPage-ClassesPage-module__pageContainer--k40Tu {
  display: flex;
  height: 100%;
  width: 100%;
  overflow: hidden;
}
.src-pages-classes-ClassesPage-ClassesPage-module__sidebarHeader--plIIV {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  padding: 0 16px;
}
.src-pages-classes-ClassesPage-ClassesPage-module__sidebarHeaderTitle--qt573 {
  display: none;
}
.src-pages-classes-ClassesPage-ClassesPage-module__sidebarContent--qfdWf {
  flex: 1;
  overflow: auto;
  display: none;
  padding: 0 16px;
}
.src-pages-classes-ClassesPage-ClassesPage-module__sidebar--OahF7 {
  overflow: hidden;
}
.src-pages-classes-ClassesPage-ClassesPage-module__sidebar--OahF7.src-pages-classes-ClassesPage-ClassesPage-module__open--MHrq1 .src-pages-classes-ClassesPage-ClassesPage-module__sidebarHeaderTitle--qt573 {
  display: flex;
  gap: 8px;
  align-items: center;
}
.src-pages-classes-ClassesPage-ClassesPage-module__sidebar--OahF7.src-pages-classes-ClassesPage-ClassesPage-module__open--MHrq1 .src-pages-classes-ClassesPage-ClassesPage-module__sidebarContent--qfdWf {
  display: block;
}
.src-pages-classes-ClassesPage-ClassesPage-module__box--A1qy5 {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}
.src-pages-classes-ClassesPage-ClassesPage-module__tools--BtdNR {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
}
.src-pages-classes-ClassesPage-ClassesPage-module__toolsTop--ZEUnE {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  gap: 8px;
}
.src-pages-classes-ClassesPage-ClassesPage-module__tableBox--UiIhG {
  flex: 1;
  overflow: hidden;
}
.src-pages-classes-ClassesPage-ClassesPage-module__settingsLink--EImv2 {
  white-space: nowrap;
}
.src-pages-classes-ClassesPage-ClassesPage-module__filtersBox--nIkYT {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}
.src-pages-classes-ClassesPage-ClassesPage-module__filtersLabel--TGIiD {
  color: rgba(0, 0, 0, 0.55);
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
}
/*# sourceMappingURL=ClassesPage.module.css.map */`, "",{"version":3,"sources":["webpack://./ClassesPage.module.less","webpack://./src/pages/classes/ClassesPage/ClassesPage.module.less"],"names":[],"mappings":"AAEA;EACE,cAAA;ACDF;ADIA;EACE,aAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;ACFF;ADKA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,eAAA;ACHF;ADMA;EACE,aAAA;ACJF;ADOA;EACE,OAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;ACLF;ADQA;EACE,gBAAA;ACNF;ADQI;EACE,aAAA;EACA,QAAA;EACA,mBAAA;ACNN;ADQI;EACE,cAAA;ACNN;ADWA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;ACTF;ADWA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;ACTF;ADYA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;ACVF;ADaA;EACE,OAAA;EACA,gBAAA;ACXF;ADcA;EACE,mBAAA;ACZF;ADeA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;ACbF;ADeA;EACE,0BAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ACbF;AACA,iDAAiD","sourcesContent":["@import \"/src/variables.less\";\n\n.icon {\n  color: @text-main;\n}\n\n.pageContainer {\n  display: flex;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n}\n\n.sidebarHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 56px;\n  padding: 0 16px;\n}\n\n.sidebarHeaderTitle {\n  display: none;\n}\n\n.sidebarContent {\n  flex: 1;\n  overflow: auto;\n  display: none;\n  padding: 0 16px;\n}\n\n.sidebar {\n  overflow: hidden;\n  &.open {\n    & .sidebarHeaderTitle {\n      display: flex;\n      gap: 8px;\n      align-items: center;\n    }\n    & .sidebarContent {\n      display: block;\n    }\n  }\n}\n\n.box {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden;\n}\n.tools {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n}\n\n.toolsTop {\n  display: flex;\n  align-items: center;\n  padding: 12px 16px;\n  gap: 8px;\n}\n\n.tableBox {\n  flex: 1;\n  overflow: hidden;\n}\n\n.settingsLink {\n  white-space: nowrap;\n}\n// ClosableTag\n.filtersBox {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n}\n.filtersLabel {\n  color: rgba(0, 0, 0, 0.55);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 160%;\n}\n",".icon {\n  color: #343a41;\n}\n.pageContainer {\n  display: flex;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n}\n.sidebarHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 56px;\n  padding: 0 16px;\n}\n.sidebarHeaderTitle {\n  display: none;\n}\n.sidebarContent {\n  flex: 1;\n  overflow: auto;\n  display: none;\n  padding: 0 16px;\n}\n.sidebar {\n  overflow: hidden;\n}\n.sidebar.open .sidebarHeaderTitle {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n.sidebar.open .sidebarContent {\n  display: block;\n}\n.box {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden;\n}\n.tools {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n}\n.toolsTop {\n  display: flex;\n  align-items: center;\n  padding: 12px 16px;\n  gap: 8px;\n}\n.tableBox {\n  flex: 1;\n  overflow: hidden;\n}\n.settingsLink {\n  white-space: nowrap;\n}\n.filtersBox {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n}\n.filtersLabel {\n  color: rgba(0, 0, 0, 0.55);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 160%;\n}\n/*# sourceMappingURL=ClassesPage.module.css.map */"],"sourceRoot":""}]);
// Exports
export var icon = `src-pages-classes-ClassesPage-ClassesPage-module__icon--RkXFv`;
export var pageContainer = `src-pages-classes-ClassesPage-ClassesPage-module__pageContainer--k40Tu`;
export var sidebarHeader = `src-pages-classes-ClassesPage-ClassesPage-module__sidebarHeader--plIIV`;
export var sidebarHeaderTitle = `src-pages-classes-ClassesPage-ClassesPage-module__sidebarHeaderTitle--qt573`;
export var sidebarContent = `src-pages-classes-ClassesPage-ClassesPage-module__sidebarContent--qfdWf`;
export var sidebar = `src-pages-classes-ClassesPage-ClassesPage-module__sidebar--OahF7`;
export var open = `src-pages-classes-ClassesPage-ClassesPage-module__open--MHrq1`;
export var box = `src-pages-classes-ClassesPage-ClassesPage-module__box--A1qy5`;
export var tools = `src-pages-classes-ClassesPage-ClassesPage-module__tools--BtdNR`;
export var toolsTop = `src-pages-classes-ClassesPage-ClassesPage-module__toolsTop--ZEUnE`;
export var tableBox = `src-pages-classes-ClassesPage-ClassesPage-module__tableBox--UiIhG`;
export var settingsLink = `src-pages-classes-ClassesPage-ClassesPage-module__settingsLink--EImv2`;
export var filtersBox = `src-pages-classes-ClassesPage-ClassesPage-module__filtersBox--nIkYT`;
export var filtersLabel = `src-pages-classes-ClassesPage-ClassesPage-module__filtersLabel--TGIiD`;
export default ___CSS_LOADER_EXPORT___;
